const LOG_IN = 'LOG_IN';
const UPDATE_LOADING = 'UPDATE_LOADING';
const UPDATE_LOADING_SCREEN = 'UPDATE_LOADING_SCREEN';
const LOGIN_DATA = 'LOGIN_DATA';
const MENU_VISIBLE = 'MENU_VISIBLE';
const MAIN_MENU = 'MAIN_MENU';
const SERVICE_MASTER_MENU = 'SERVICE_MASTER_MENU';
const STOCK_MANAGEMENT_MENU = 'STOCK_MANAGEMENT_MENU';
const OTHERS_MENU = 'OTHERS_MENU';
const ROUTE_MENU = 'ROUTE_MENU';
const MASTER_CONFIG_MENU = 'MASTER_CONFIG_MENU';
const USER_CONFIG_MENU = 'USER_CONFIG_MENU';
const CARGO_RATE_CONFIG = 'CARGO_RATE_CONFIG'
const BOOKING_MENU = 'BOOKING_MENU'
const TOP_UP_MENU = 'TOP_UP_MENU'
const ROLE_DATA = 'ROLE_DATA'
const LAYOUT_CONFIG_MENU = 'LAYOUT_CONFIG_MENU';
const FARE_CONFIG_MENU = 'FARE_CONFIG_MENU';
const UPDATE_USER_DATA = 'UPDATE_USER_DATA'
const LOGOUT = 'LOGOUT'
const REPORT_MENU = 'REPORT_MENU'
const GENERAL_REPORT_MENU = 'GENERAL_REPORT_MENU'
const CASUAL_CONTRACT_REPORT_MENU = 'CASUAL_CONTRACT_REPORT_MENU'
const ACCOUNTS_REPORT_MENU = 'ACCOUNTS_REPORT_MENU'
const ONLINE_REPORT_MENU = 'ONLINE_REPORT_MENU'
const OTHER_REPORT_MENU = 'OTHER_REPORT_MENU'
const CARGO_REPORT_MENU = 'CARGO_REPORT_MENU'
const PPR_MANAGEMENT_MENU = 'PPR_MANAGEMENT_MENU'
const CARGO_MENU = 'CARGO_MENU'
const KSTDC_REPORT_MENU = 'KSTDC_REPORT_MENU'
const UPDATE_IP_ADDRESS = 'UPDATE_IP_ADDRESS'
const MASTER_CODE_ALLVALUE = 'MASTER_CODE_ALLVALUE'
const COMPLAINT_MANAGEMENT = 'COMPLAINT_MANAGEMENT'
const CASUAL_CONTRACT_MENU = 'CASUAL_CONTRACT_MENU'
const UPDATE_REVOKE_SERIVE_DATE = 'UPDATE_REVOKE_SERIVE_DATE'
//-----
const CARGO_REPORT_MAIN_MENU = 'CARGO_REPORT_MAIN_MENU'
const CARGO_DC_REPORT_MENU = 'CARGO_DC_REPORT_MENU'
const CARGO_DASHBOARD_REPORT_MENU = 'CARGO_DASHBOARD_REPORT_MENU'
const CARGO_OPERATIONS_REPORT_MENU = 'CARGO_OPERATIONS_REPORT_MENU'
const CARGO_ACCOUNTS_REPORT_MENU = 'CARGO_ACCOUNTS_REPORT_MENU'
//--------
const KSDTC_BOOKING_MENU='KSDTC_BOOKING_MENU'
export default {
    LOG_IN,
    UPDATE_LOADING,
    UPDATE_LOADING_SCREEN,
    LOGIN_DATA,
    MENU_VISIBLE,
    MAIN_MENU,
    SERVICE_MASTER_MENU,
    STOCK_MANAGEMENT_MENU,
    OTHERS_MENU,
    ROUTE_MENU,
    CASUAL_CONTRACT_MENU,
    MASTER_CONFIG_MENU,
    USER_CONFIG_MENU,
    CARGO_RATE_CONFIG,
    BOOKING_MENU,
    TOP_UP_MENU,
    ROLE_DATA,
    LAYOUT_CONFIG_MENU,
    FARE_CONFIG_MENU,
    UPDATE_USER_DATA,
    LOGOUT,
    REPORT_MENU,
    GENERAL_REPORT_MENU,
    CASUAL_CONTRACT_REPORT_MENU,
    ACCOUNTS_REPORT_MENU,
    ONLINE_REPORT_MENU,
    OTHER_REPORT_MENU,
    KSTDC_REPORT_MENU,
    UPDATE_IP_ADDRESS,
    MASTER_CODE_ALLVALUE,
    CARGO_REPORT_MENU,
    PPR_MANAGEMENT_MENU,
    CARGO_MENU,
    UPDATE_IP_ADDRESS,
    COMPLAINT_MANAGEMENT,
    UPDATE_IP_ADDRESS,
    MASTER_CODE_ALLVALUE,
    UPDATE_REVOKE_SERIVE_DATE,
    CARGO_REPORT_MAIN_MENU,
    CARGO_DC_REPORT_MENU,
    CARGO_DASHBOARD_REPORT_MENU,
    CARGO_OPERATIONS_REPORT_MENU,
    CARGO_ACCOUNTS_REPORT_MENU,
    UPDATE_REVOKE_SERIVE_DATE,
    KSDTC_BOOKING_MENU
}
